import React from "react";
import styles from "./index.module.scss";
import moment from "moment";
import { PRETypes } from "../../../../../../stories/common/flipper-vault-card";
import { formatCurrency } from "../../../../../../utils/utils";

interface AddressModalProps {
  isScrolled?: boolean;
  preData: PRETypes[];
}

export default function PREListing({ isScrolled, preData }: AddressModalProps) {
  return (
    <div className={styles.AddressSection}>
      <div className={styles.header}>
        <div className={`${styles.addressTitle} ${styles.cellHeader}`}>
          Address
        </div>
        <div className={`${styles.priceTitle} ${styles.cellHeader}`}>
          Purchased Price
        </div>
        <div className={`${styles.dateTitle} ${styles.cellHeader} `}>
          Purchased Date
        </div>
        <div className={`${styles.LenderTitle} ${styles.cellHeader}`}>
          Lender
        </div>
        <div className={`${styles.TypeTitle} ${styles.cellHeader}`}>Type</div>
      </div>
      {preData === null || preData?.length === 0 ? (
        <div className={styles.noData}>No PRE found</div>
      ) : (
        <>
          {preData?.map((item: PRETypes, index: number) => (
            <div key={index} className={styles.content}>
              <div className={`${styles.address} ${styles.cell}`}>
                {item.situsFullAddress}, {item.situsCity}, {item.situsState}{" "}
                {item.situsZIP5}
              </div>
              <div className={`${styles.cell} ${styles.Price}`}>
                {item?.currentSalesPrice
                  ? formatCurrency(+item?.currentSalesPrice, "USD", "en-US")
                  : "N/A"}
              </div>
              <div className={`${styles.date} ${styles.cell}`}>
                {item?.currentSaleRecordingDate
                  ? moment(item?.currentSaleRecordingDate, "YYYYMMDD").format(
                      "MM/DD/YYYY"
                    )
                  : "N/A"}
              </div>
              <div className={`${styles.Lender} ${styles.cell}`}>
                {item.concurrentMtg1Lender ? item.concurrentMtg1Lender : "N/A"}
              </div>
              <div className={`${styles.statusTag} ${styles.cell}`}>
                <div
                  className={`${styles.statusBox} ${
                    !item?.isFlipper ? styles.pre : ""
                  }`}
                >
                  {item?.isFlipper ? "FLIP" : "PRE"}
                </div>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
